import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import NewPreviewComponent from './NewPreviewComponent.jsx'
import MobilePreview from "../PreviewComponent/MobilePreviewComponents/MobilePreview.jsx";
import axios from "axios";
import { BASEURL } from '../../../constants.js';
import { useLocation } from "react-router-dom";

const Preview = () => {
    const [type, setType] = useState('desktop');
    const [courseInfo, setCourseInfo] = useState(null);

    const location = useLocation();
    const baseRoute = location.pathname.split('/')[1];
    const { courseId } = useParams();
    useEffect(() => {
        axios.get(`${BASEURL}/api/fetch-course-info`, {
            params: {
                courseId: courseId
            }
        }).then((res) => {
            console.log(res.data.rows, res.data);
            setCourseInfo(res.data.rows)
        })
    }, [])

    return (
        <>
            <NewPreviewComponent />
        </>
    )

}

export default Preview;






